module.exports = __webpack_public_path__ + "img/Korean.90003c26.jpeg";